export const guidelinesUrls = {
  ja: "https://sekaie.notion.site/SoulChat-1f00a885c19e800f9189d154eaf2a2bf",
  en: "https://sekaie.notion.site/SoulChat-Usage-Guidelines-1f00a885c19e8021bdb1fd1fb81324f3",
  ko: "https://sekaie.notion.site/SoulChat-1f00a885c19e8069b1cee560ee6ea6b5",
  "zh-TW":
    "https://sekaie.notion.site/SoulChat-1f00a885c19e802799abdd087e4c7e72",
};

const workGuidelinesUrls = {
  yofukashi: {
    ja: "https://soulchat.jp/yofukashi/guidelines",
  },
  chi: {
    ja: "https://soulchat.jp/chi/guidelines",
  },
  jashindp: {
    ja: "https://soulchat.jp/jashindp/guidelines",
  },
  higurashi: {
    ja: "https://soulchat.jp/higurashi/guidelines",
  },
  potion: {
    ja: "https://soulchat.jp/potion/guidelines",
  },
};

export const getGuidelinesUrl = (work, lng = "ja") => {
  const language = lng || "ja";
  return (
    workGuidelinesUrls[work]?.[language] ||
    guidelinesUrls[language] ||
    guidelinesUrls.ja
  );
};

export const termsOfServiceUrls = {
  ja: "https://soulchat.jp/terms",
  en: "https://sekaie.notion.site/SoulChat-Terms-of-Service-1e70a885c19e805f8ed3eb0b530f0647",
  ko: "https://sekaie.notion.site/SoulChat-1e70a885c19e8093a581fed2e6f02af7",
  "zh-TW":
    "https://sekaie.notion.site/SoulChat-1e70a885c19e805c90e7e42f208353ba?pvs=4",
};

export const privacyPolicyUrls = {
  ja: "https://sekaie.notion.site/1960a885c19e801aa6c5f7cc9e3b4203",
  en: "https://sekaie.notion.site/Privacy-Policy-1e70a885c19e801cb605e1c4526aa04c",
  ko: "https://sekaie.notion.site/1e70a885c19e809bbab9f2e4a5efb4d4",
  "zh-TW": "https://sekaie.notion.site/1e70a885c19e807f9d31e3beca5249ae",
};

export const howToUseDetailUrls = {
  chi: {
    ja: "https://sekaie.notion.site/1960a885c19e80b995f4f433c46a5bee",
    en: "https://sekaie.notion.site/1960a885c19e80b995f4f433c46a5bee",
    ko: "https://sekaie.notion.site/SoulChat-for-2e40b030e38e46ad87c726c22d070434",
    "zh-TW":
      "https://sekaie.notion.site/SoulChat-for-9bbb9dda3ab3472c826216114e5aa70a",
  },
  potion: {
    ja: "https://sekaie.notion.site/SoulChat-25c0a885c19e80e9b3c3fe612a8d63cc", // TODO: Replace with Potion-specific URL when ready
  },
  common: {
    ja: "https://sekaie.notion.site/SoulChat-25c0a885c19e80e9b3c3fe612a8d63cc",
  },
};

export const modeDescriptionUrls = {
  ja: "https://sekaie.notion.site/SoulChat-2020a885c19e80159fcdf7c2824dc568",
  en: "https://sekaie.notion.site/SoulChat-2020a885c19e80159fcdf7c2824dc568",
  ko: "https://sekaie.notion.site/SoulChat-2260a885c19e809d84b4c3cfbba670f1",
  "zh-TW":
    "https://sekaie.notion.site/SoulChat-21f0a885c19e80b7a135f04e4eaf6dad",
};

export const memoryRollbackUrls = {
  ja: "https://docs.google.com/forms/d/e/1FAIpQLSdrLhdbrjXkNCQ6hsq-B14Csm1HoHHtwQuvqzTLn6sZV3HzqQ/viewform",
  en: "https://docs.google.com/forms/d/e/1FAIpQLSdrLhdbrjXkNCQ6hsq-B14Csm1HoHHtwQuvqzTLn6sZV3HzqQ/viewform",
  ko: "https://docs.google.com/forms/d/e/1FAIpQLSdrLhdbrjXkNCQ6hsq-B14Csm1HoHHtwQuvqzTLn6sZV3HzqQ/viewform",
  "zh-TW":
    "https://docs.google.com/forms/d/e/1FAIpQLSdrLhdbrjXkNCQ6hsq-B14Csm1HoHHtwQuvqzTLn6sZV3HzqQ/viewform",
};

export const requestFormUrls = {
  ja: "https://docs.google.com/forms/d/e/1FAIpQLScugH6agsvfRIDA0H9i8tZoT_vCZdJq9aHmQsbXaYdBPNMfpg/viewform?usp=dialog",
  en: "https://docs.google.com/forms/d/e/1FAIpQLScugH6agsvfRIDA0H9i8tZoT_vCZdJq9aHmQsbXaYdBPNMfpg/viewform?usp=dialog",
  ko: "https://docs.google.com/forms/d/e/1FAIpQLScugH6agsvfRIDA0H9i8tZoT_vCZdJq9aHmQsbXaYdBPNMfpg/viewform?usp=dialog",
  "zh-TW":
    "https://docs.google.com/forms/d/e/1FAIpQLScugH6agsvfRIDA0H9i8tZoT_vCZdJq9aHmQsbXaYdBPNMfpg/viewform?usp=dialog",
};

export const getRequestFormUrl = (lng) =>
  requestFormUrls[lng] || requestFormUrls.ja || "";

export const lineAccountLinks = {
  chi: {
    ja: {
      rafal: "https://lin.ee/sdeAKC4",
      badeni: "https://lin.ee/6mtdT28",
      "jolenta-girl": "https://lin.ee/j5fr7Vf",
      "jolenta-woman": "https://lin.ee/DS20Baz",
      oczy: "https://lin.ee/NodtclU",
      "nowak-chapter2": "https://lin.ee/IWcHbRd",
      "nowak-chapter3": "https://lin.ee/v4FZCtJ",
      draka: "https://lin.ee/Ov4arA9",
    },
    en: {
      rafal: "https://lin.ee/bcUBfWK",
    },
    "zh-TW": {
      rafal: "https://lin.ee/PrmYdOV",
      badeni: "https://lin.ee/tIFjWfO",
      "jolenta-girl": "https://lin.ee/PDseVQk",
    },
    ko: {
      rafal: "https://lin.ee/3IE8aIJ",
    },
  },
  yofukashi: {
    ja: {
      nazuna: "https://lin.ee/HdaFJYO",
      yamori: "https://lin.ee/Ub6t91F",
      anko: "https://lin.ee/IMSwkLC",
      kabura: "https://lin.ee/iQ6Lcb8f",
      hatsuka: "https://lin.ee/jpg5hme",
      seri: "https://lin.ee/k8CRuHT",
      midori: "https://lin.ee/t4IJgBe",
      nico: "https://lin.ee/ZMWj7vF",
    },
  },
  jashindp: {
    ja: {
      jashinchan: "https://lin.ee/cay3FD3",
      yurine: "https://lin.ee/pyJ1N5H",
    },
  },
  higurashi: {
    ja: {
      original: {
        keiichi: "https://lin.ee/7xQjItm",
        rena: "https://lin.ee/PCfLdHD",
        mion: "https://lin.ee/zVj3uoL",
      },
      cs: {
        keiichi: "https://lin.ee/vACsCtf",
        rena: "https://lin.ee/y22Qxd6",
        mion: "https://lin.ee/6RAqLxy",
      },
    },
  },
};
